/* assets/sticky-add-to-cart.js
   - Safe for older parsers (NO optional chaining / nullish coalescing)
   - Prevent double define in Theme Editor / hot reload
*/
(function () {
  // Prevent double-load issues
  if (window.customElements && window.customElements.get("sticky-add-to-cart")) return;

  function safeGetAttr(el, attr) {
    return el && el.getAttribute ? el.getAttribute(attr) : null;
  }

  function safeQuery(root, sel) {
    return root && root.querySelector ? root.querySelector(sel) : null;
  }

  function safeQueryAll(root, sel) {
    return root && root.querySelectorAll ? root.querySelectorAll(sel) : [];
  }

  function dispatchHelperEvent(name, el, detail) {
    try {
      if (window.HELPER_UTIL && typeof window.HELPER_UTIL.dispatchCustomEvent === "function") {
        window.HELPER_UTIL.dispatchCustomEvent(name, el, detail || {});
      } else {
        // fallback: native CustomEvent
        var evt = new CustomEvent(name, { detail: detail || {} });
        el.dispatchEvent(evt);
      }
    } catch (e) {}
  }

  class StickyAddToCart extends HTMLElement {
    constructor() {
      super();

      var contentEl = safeQuery(this, "sticky-add-to-cart-content");
      this.layout_type = safeGetAttr(contentEl, "layout-type") || "";

      var drawerEl = safeQuery(this, "[drawer-to-open]");
      this.drawerType = drawerEl ? safeGetAttr(drawerEl, "drawer-to-open") : "sticky-add-to-cart-drawer";

      this.variantList = safeQuery(this, "[sticky-add-to-cart-variants]");
      this.addToCartButton = safeQuery(this, "[add-to-cart-button]");

      this._boundUpdate = this._updateStickyAddToCartContent.bind(this);
      this._boundUpdateUnavailable = this._updateStickyAddToCartContentUnAvailable.bind(this);

      if (window._EVENT_HELPER) {
        document.addEventListener(window._EVENT_HELPER.updateStickyAddToCartContent, this._boundUpdate);
        document.addEventListener(window._EVENT_HELPER.updateStickyAddToCartContentUnAvailable, this._boundUpdateUnavailable);
      }
    }

    _updateStickyAddToCartContent(e) {
      var list = (e && e.detail && e.detail.sticky_content) ? e.detail.sticky_content : [];
      for (var i = 0; i < list.length; i++) {
        var element = list[i];
        if (!element || !element.querySelector) continue;

        var stickyElement = element.querySelector("sticky-add-to-cart-content");
        if (!stickyElement) continue;

        if (safeGetAttr(stickyElement, "layout-type") === this.layout_type) {
          var target = safeQuery(this, "[sticky-add-to-cart-content]");
          if (target) target.innerHTML = element.innerHTML;
        }
      }
    }

    _updateStickyAddToCartContentUnAvailable(e) {
      var options = (e && e.detail && e.detail.variantOptions) ? e.detail.variantOptions : [];
      if (this.variantList) this.variantList.textContent = options.join(", ");
      this.togleAddToCartButton(false);
    }

    disconnectedCallback() {
      if (window._EVENT_HELPER) {
        document.removeEventListener(window._EVENT_HELPER.updateStickyAddToCartContent, this._boundUpdate);
        document.removeEventListener(window._EVENT_HELPER.updateStickyAddToCartContentUnAvailable, this._boundUpdateUnavailable);
      }
    }

    togleAddToCartButton(buttonEnabled) {
      if (!this.addToCartButton) return;

      if (buttonEnabled) {
        this.addToCartButton.removeAttribute("disabled");
        return;
      }

      if (!this.addToCartButton.classList.contains("sticky-icon-button")) {
        var unavailable = (window.variantStrings && window.variantStrings.unavailable) ? window.variantStrings.unavailable : "Unavailable";
        this.addToCartButton.textContent = unavailable;
      }
      this.addToCartButton.removeAttribute("form");
      this.addToCartButton.setAttribute("disabled", "disabled");
    }
  }

  window.customElements.define("sticky-add-to-cart", StickyAddToCart);

  // If content element already registered, stop here
  if (window.customElements.get("sticky-add-to-cart-content")) return;

  class StickyAddToCartContent extends HTMLElement {
    constructor() {
      super();

      this.addToCartButton = safeQuery(this, "[add-to-cart-button]");
      this.buttonContainer = safeQuery(this, "[stikcy-add-to-cart-button-content]");

      // bind handlers once (so removeEventListener works)
      this._onClick = this._onClick.bind(this);
      this._boundScrollHandler = this._scrollHandler.bind(this);
      this._boundResize = this.screenResize.bind(this);
      this._boundScrollToSection = this._scrollToSection.bind(this);

      // host drawerType (from closest sticky-add-to-cart)
      var host = this.closest("sticky-add-to-cart");
      if (host) {
        // if host.drawerType exists (instance property)
        this.drawerType = host.drawerType || "sticky-add-to-cart-drawer";
        if (!this.drawerType) {
          var drawerEl = safeQuery(host, "[drawer-to-open]");
          this.drawerType = drawerEl ? safeGetAttr(drawerEl, "drawer-to-open") : "sticky-add-to-cart-drawer";
        }
      } else {
        this.drawerType = "sticky-add-to-cart-drawer";
      }

      if (this.addToCartButton) {
        this.addToCartButton.addEventListener("click", this._onClick);
      }

      this._product_container = document.querySelector("[product-container]");
      this._drawerScrollToSection = document.querySelector("drawer-component [scroll-to-section]");
      this._scrollToSectionButton = safeQuery(this, "[scroll-to-section]");
      this.breakpoint = window.matchMedia ? window.matchMedia("(min-width:768px)") : { matches: true };

      if (window._EVENT_HELPER) {
        document.addEventListener(window._EVENT_HELPER.resetStickyAddTocartButton, () => {
          try {
            if (window.HELPER_UTIL && typeof window.HELPER_UTIL.submitButtonState === "function") {
              var st = window.HELPER_UTIL.submitButtonState(this.addToCartButton);
              if (st && st.resetState) st.resetState(1000);
              if (st && st.disableState) st.disableState(false);
            }
          } catch (e) {}
        });

        document.addEventListener(window._EVENT_HELPER.triggerVariantAddToCartError, (e) => {
          var h = this.closest("sticky-add-to-cart");
          var state = h ? h.getAttribute("aria-hidden") : null;
          if (state === "false") this._scrollToSection(e);
        });
      }

      document.addEventListener("scroll", this._boundScrollHandler, { passive: true });
      window.addEventListener("resize", this._boundResize, { passive: true });

      if (this._scrollToSectionButton) {
        this._scrollToSectionButton.addEventListener("click", this._boundScrollToSection);
      }
      if (this._drawerScrollToSection) {
        this._drawerScrollToSection.addEventListener("click", this._boundScrollToSection);
      }

      var s1 = this._scrollToSectionButton ? safeGetAttr(this._scrollToSectionButton, "scroll-to-section") : null;
      var s2 = this._drawerScrollToSection ? safeGetAttr(this._drawerScrollToSection, "scroll-to-section") : null;
      this.scrollTosection = s1 || s2 || null;

      this.scrollTosectionElement = this.scrollTosection
        ? document.querySelector("#shopify-section-" + this.scrollTosection + " [variant-block]")
        : null;

      this.scrollTosectionElementOffset = 0;
      this._totalScrollHeight = 0;
    }

    connectedCallback() {
      if (!this._product_container) return;

      this._product_containerOffsetTop = this._product_container.offsetTop || 0;
      this._product_containerHeight = this._product_container.offsetHeight || 0;
      this._totalScrollHeight = this._product_containerOffsetTop + this._product_containerHeight;

      this.screenResize();
    }

    _onClick(e) {
      try {
        if (window.HELPER_UTIL && typeof window.HELPER_UTIL.submitButtonState === "function") {
          var st = window.HELPER_UTIL.submitButtonState(this.addToCartButton);
          if (st && st.loadingState) st.loadingState();
        }

        var formId = this.addToCartButton ? this.addToCartButton.getAttribute("form") : null;
        var formEl = formId ? document.getElementById(formId) : null;

        if (formEl) {
          dispatchHelperEvent("submit", formEl, {});
        }
      } catch (err) {}
    }

    _scrollToSection(e) {
      try {
        if (e && typeof e.preventDefault === "function") e.preventDefault();
      } catch (_) {}

      // hide drawer
      if (window._EVENT_HELPER && window._EVENT_HELPER.hideDrawer) {
        dispatchHelperEvent(window._EVENT_HELPER.hideDrawer, this, { drawerType: this.drawerType });
      }

      if (this.scrollTosectionElementOffset > 0) {
        window.scrollTo({ top: this.scrollTosectionElementOffset, behavior: "smooth" });
      }
    }

    screenResize() {
      if (!this.scrollTosectionElement) return;

      if (this.breakpoint && this.breakpoint.matches === true) {
        var baseTop = this._product_container ? (this._product_container.offsetTop || 0) : 0;
        this.scrollTosectionElementOffset = (this.scrollTosectionElement.offsetTop || 0) + baseTop;
      } else {
        var infoTopEl = document.querySelector("[scroll-product-info]");
        var infoTop = infoTopEl ? (infoTopEl.offsetTop || 0) : 0;
        this.scrollTosectionElementOffset = infoTop + (this.scrollTosectionElement.offsetTop || 0);
      }
    }

    _scrollHandler() {
      if (!this._totalScrollHeight) return;

      var host = this.closest("sticky-add-to-cart");
      if (!host) return;

      var isMobile = window.innerWidth <= 767;

      if (window.scrollY > this._totalScrollHeight) {
        host.classList.add("active");
        // [MOBILE FIX] Thêm padding-bottom vào body để content không bị che bởi sticky bar
        if (isMobile) document.body.classList.add("sticky-bar-active");
      } else {
        host.classList.remove("active");
        // [MOBILE FIX] Xóa padding khi sticky bar ẩn đi
        if (isMobile) document.body.classList.remove("sticky-bar-active");
      }
    }

    disconnectedCallback() {
      document.removeEventListener("scroll", this._boundScrollHandler);
      window.removeEventListener("resize", this._boundResize);

      if (this._scrollToSectionButton) {
        this._scrollToSectionButton.removeEventListener("click", this._boundScrollToSection);
      }
      if (this._drawerScrollToSection) {
        this._drawerScrollToSection.removeEventListener("click", this._boundScrollToSection);
      }
      if (this.addToCartButton) {
        this.addToCartButton.removeEventListener("click", this._onClick);
      }
    }
  }

  window.customElements.define("sticky-add-to-cart-content", StickyAddToCartContent);
})();